enum MAIN {
	ATTENDANCE_BY_WEEK_ID = '/api/attendance/main/',
	GRANDING = '/api/attendance/group/',
	SUMMARY = '/api/attendance/group/'
}

enum PRESENCE {
	PRESENCE = '/api/attendance/presence',
	PRESENCE_BY_ID = '/api/attendance/presence/',
	PRESENCE_BY_IDS = '/api/attendance/presence/respectableAbsents',
	PRESENCE_HISTORY_BY_ID = 'api/attendance/presence/history/'
}

enum ABSENCE {
	ABSENCE = '/api/attendance/absence'
}

enum COMPLETED_CLASSES {
	MAIN = '/api/attendance/completedClasses'
}

export default {
	MAIN,
	PRESENCE,
	ABSENCE,
	COMPLETED_CLASSES
};
